export default __webpack_public_path__ + "static/media/downArrowInput.571ef75d.svg";